import React, { useMemo } from "react";
import { Box, Grid, Paper } from "@material-ui/core";
import { ContactFields, buildContactInfo } from "./ContactFields";
import { ContactField } from "./ContactField";
import { AddressFields } from "./AddressFields";
import { AccountContact } from "../../../api/services";

export const ContactPanel: React.FC<{
  contact: AccountContact;
  ref?: any;
}> = React.forwardRef(({ contact }, ref) => {
  const info = useMemo(() => buildContactInfo(contact), [contact]);
  const { address } = contact;
  return (
    // @ts-ignore
    <Box py={2} ref={ref}>
      <Paper elevation={4}>
        <Box p={3}>
          <Grid container>
            <Grid item xs={6}>
              <Box pr={1} height={1} overflow={"hidden"}>
                <ContactFields {...info} />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box pr={1} height={1} overflow={"hidden"}>
                <AddressFields {...address} />
              </Box>
            </Grid>
            <Box>
              <ContactField label="Email" value={info.email} />
            </Box>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
});
